import { render, staticRenderFns } from "./SelectCustomer.vue?vue&type=template&id=6d3f6877&scoped=true&"
import script from "./SelectCustomer.vue?vue&type=script&lang=js&"
export * from "./SelectCustomer.vue?vue&type=script&lang=js&"
import style0 from "./SelectCustomer.vue?vue&type=style&index=0&id=6d3f6877&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3f6877",
  null
  
)

export default component.exports